<!-- Flat card: every part is a direct grid child of .ws-product-card (layout in styles/themable/_product-card.scss). -->
<div class="ws-product-card ws-product-card--pieces ws-product-card--overlay-always"
     [ngClass]="cardClasses()"
     (click)="onCardClick($event)">
  <ng-container *ngTemplateOutlet="blocks().media"></ng-container>
  <ng-container *ngTemplateOutlet="blocks().badges"></ng-container>
  <ng-container *ngTemplateOutlet="blocks().cartCount"></ng-container>

  <!-- desktop overlay -->
  <div class="ws-product-card__overlay-panel ws-product-card__overlay-part ws-product-card__media-part ws-product-card__only-desktop"></div>

  <a class="ws-product-card__overlay-link ws-product-card__overlay-part ws-product-card__media-part ws-product-card__only-desktop"
     [routerLink]="builderLink()?.link"
     [queryParams]="builderLink()?.queryParams"></a>

  <div class="text-center px-3 mb-3 ws-product-card__overlay-title ws-product-card__overlay-title--tight ws-product-card__overlay-part ws-product-card__media-part ws-product-card__only-desktop">{{ cake().name }}</div>

  @if (cake().showQuantityPicker) {
    <ui-single-pieces-counter
      class="pieces-counter-wrapper ws-product-card__counter ws-product-card__overlay-part ws-product-card__media-part ws-product-card__only-desktop"
      [step]="cake().increment"
      [minCount]="cake().minQuantity"
      [maxCount]="maxCount()"
      [count]="itemCount()"
      [size]="'md'"
      [btnStyle]="'btn-pink'"
      [btnHighlighting]="true"
      [isPlusDisabled]="isCounterPlusDisabled()"
      (onCountUpdated)="updateCount($event)"
    ></ui-single-pieces-counter>

    <a class="btn ws-button ws-button--primary btn-slim font-sm fw-normal ws-product-card__info-btn ws-product-card__overlay-action ws-product-card__info ws-product-card__overlay-part ws-product-card__media-part ws-product-card__only-desktop"
       [routerLink]="builderLink()?.link"
       [queryParams]="builderLink()?.queryParams">
      @if (canHasAddOns()) {
        <span [translate]="'orderProcess.cakesOverview.cakeItem.customiseOrSeeInfo'"></span>
      } @else {
        <span [translate]="'orderProcess.cakesOverview.cakeItem.seeInfo'"></span>
      }
    </a>
  } @else {
    <a class="btn ws-button ws-button--primary btn-long ws-product-card__order-now ws-product-card__overlay-part ws-product-card__media-part ws-product-card__only-desktop"
       [routerLink]="builderLink()?.link"
       [queryParams]="builderLink()?.queryParams"
       [translate]="'common.orderNow'">
      Order now
    </a>
  }

  <!-- mobile overlay -->
  @if (itemCount()) {
    <div class="ws-product-card__tap-area ws-product-card__overlay-part ws-product-card__media-part ws-product-card__only-touch"
         (click)="$event.stopPropagation(); open.emit()"></div>

    @if (canHasAddOns()) {
      <button class="btn ws-button ws-button--accent btn-slim font-sm fw-normal ws-product-card__info-btn ws-product-card__customize ws-product-card__overlay-part ws-product-card__media-part ws-product-card__only-touch"
              [translate]="'orderProcess.cakesOverview.cakeItem.customize'"
              (click)="$event.stopPropagation(); open.emit()">
        Customize
      </button>
    }

    <ui-single-pieces-counter
      class="pieces-counter-wrapper ws-product-card__counter ws-product-card__counter--mobile ws-product-card__overlay-part ws-product-card__media-part ws-product-card__only-touch"
      [step]="cake().increment"
      [minCount]="cake().minQuantity"
      [maxCount]="maxCount()"
      [count]="itemCount()"
      [size]="'md'"
      [btnStyle]="'btn-pink'"
      [btnHighlighting]="true"
      [isPlusDisabled]="isCounterPlusDisabled()"
      (onCountUpdated)="updateCount($event)"
    ></ui-single-pieces-counter>
  } @else {
    <!-- a tap here bubbles to the card: on touch devices the container opens the product -->
    <div class="ws-product-card__tap-area ws-product-card__overlay-part ws-product-card__media-part ws-product-card__only-touch"></div>

    <button class="btn ws-product-card__only-touch ws-button ws-button--primary ws-product-card__buy ws-product-card__buy--overlay ws-product-card__overlay-part ws-product-card__media-part"
            [translate]="'orderProcess.cakesOverview.cakeItem.buy'"
            (click)="cake().showQuantityPicker ? onBuy() : open.emit()">Buy
    </button>
  }

  <ng-container *ngTemplateOutlet="blocks().footer"></ng-container>
</div>
